import { Sparkle } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const SparkleIcon = createLucideIcon(Sparkle);
